<template>
  <vx-card class="overflow-hidden" v-on="$listeners">
    <template slot="no-body">
      <div class="w-full flex flex-col md:flex-row item-details no-gutter">
        <!-- IMG COL -->
        <div class="w-full md:w-1/4 bg-white flex items-center justify-center cursor-pointer" @click="navigate2Detail">
          <img :src="product.image" :alt="productLang.name" class="p-4">
        </div>

        <!-- ITEM NAME & DESC COL -->
        <div class="w-full md:w-1/2">
          <div class="p-4 pt-6">
            <h6 class="font-semibold mb-1 cursor-pointer hover:text-primary" @click="navigate2Detail">
              {{ product.code }} - {{ productLang.name }}
            </h6>

            <div class="w-full flex py-2">
              <h5 class="font-bold text-primary">
                <span v-if="$store.state.Profile.isBRL()"> {{ product.getPrice() | BRL }} </span>
                <span v-else> {{ product.getPrice() | USD }} </span>
              </h5>
            </div>

            <slot name="item-meta" v-bind:product="product" v-bind:productParamLang="productLang" />

            <span class="text-sm font-bold text-secondary"> {{ $t('pages.products.lang.description') }} </span>
            <div class="flex inline-block">
          <span class="text-sm text-secondary text-justify flex break-words inline-block">
            {{ productLang.description | readMore(350) }}
          </span>
            </div>
          </div>
        </div>

        <!-- PURCHASE COL -->
        <div class="w-full md:w-1/4 flex items-center md:border-l d-theme-border-grey-light">
          <div class="w-full flex flex-col p-2">
            <div class="my-4">

              <!-- Unitary price -->
              <div class="flex justify-between mb-2">
                <p class="item-description text-sm">{{ $t('pages.shop.checkout.tab1.price') }}</p>

                <h5 class="font-bold text-center">
                  <span v-if="$store.state.Profile.isBRL()"> {{ product.getPrice(1) | BRL }} </span>
                  <span v-if="$store.state.Profile.isUSD()"> {{ product.getPrice(1) | USD }} </span>
                </h5>
              </div>

              <!-- Combo discounts -->
              <div class="flex justify-between mb-2" v-if="product.discount > 0">
                <p class="item-description text-sm"> {{ $t('pages.shop.checkout.tab1.comboDiscount') }} </p>
                <h5 class="font-bold text-center text-sm" v-if="$store.state.Profile.isBRL()">({{ product.discount }}%) {{ product.getDiscount() | BRL }}</h5>
                <h5 class="font-bold text-center text-sm" v-else>({{ product.discount }}%) {{ product.getDiscount() | USD }}</h5>
              </div>

              <vs-divider />

              <div class="flex justify-between mb-2">
                <p class="item-description text-sm"> {{ $t('pages.shop.checkout.tab1.total') }} </p>
                <h5 class="font-bold text-center" v-if="$store.state.Profile.isBRL()">{{ product.getPrice(1) | BRL }}</h5>
                <h5 class="font-bold text-center" v-else>{{ product.getPrice(1) | USD }}</h5>
              </div>
            </div>

            <!-- SLOT: ACTION BUTTONS -->
            <slot name="action-buttons" :product="product"/>
          </div>
        </div>
      </div>
    </template>

<!--    <div v-if="product.hasManufacture()" class="pl-10">-->
<!--      <bds-label :text-help="$t('Pode ser comprado somente o planejamento e o doutor imprimir no laboratório de preferencia')"-->
<!--                 class="text-xl font-bold text-primary-t">-->
<!--        {{ $t('impressao.shop.TODO ARRUMAR') }}-->
<!--      </bds-label>-->

<!--      <div class="w-full flex flex-col md:flex-row item-details">-->
<!--        &lt;!&ndash; IMG COL &ndash;&gt;-->
<!--        <div class="w-full md:w-1/4 bg-white flex items-center justify-center cursor-pointer" @click="navigate2Detail">-->
<!--          <img :src="productManufactureData.image" :alt="productLang.name" class="p-2">-->
<!--        </div>-->

<!--        &lt;!&ndash; ITEM NAME & DESC COL &ndash;&gt;-->
<!--        <div class="w-full md:w-3/4 p-2">-->
<!--          <h6 class="font-semibold mb-1 cursor-pointer hover:text-primary" @click="navigate2Detail">-->
<!--            {{ productManufactureData.code }} - {{ productLang.name }}-->
<!--          </h6>-->

<!--          <div class="w-full flex py-2">-->
<!--            <h5 class="font-bold text-primary">-->
<!--              <span v-if="$store.state.Profile.isBRL()"> {{ productManufactureData.getPrice() | BRL }} </span>-->
<!--              <span v-else> {{ productManufactureData.getPrice() | USD }} </span>-->
<!--            </h5>-->
<!--          </div>-->

<!--          <span class="text-sm font-bold text-secondary"> {{ $t('pages.products.lang.description') }} </span>-->
<!--          <div class="flex inline-block">-->
<!--            <span class="text-sm text-secondary text-justify flex break-words inline-block">-->
<!--              {{ productLang.description | readMore(350) }}-->
<!--            </span>-->
<!--          </div>-->
<!--        </div>-->
<!--      </div>-->
<!--    </div>-->
  </vx-card>
</template>

<script>
  export default {
    name: 'item-list-view',
    props: {
      productData: {
        type: Object,
        required: true
      },
    },
    data() {
      return {

      }
    },
    computed: {
      productLang() {
        const locale = this.$i18n.locale;
        return this.product[locale];
      },
      product() {
        return this.productData;
      },
    },
    methods: {
      navigate2Detail() {
        this.$router.push({name: 'shop-item', params: {item_id: this.productData.id}});
      },
    },
    created() {

    },
    mounted() {

    }
  }
</script>

<style lang="scss" scoped>
  .list-view-item {
    .item-name, .item-description {
      display: -webkit-box;
      -webkit-box-orient: vertical;
      overflow: hidden;
    }

    .item-name {
      -webkit-line-clamp: 2;
    }

    .item-description {
      -webkit-line-clamp: 5;
    }

    .grid-view-img {
      max-width: 100%;
      max-height: 100%;
      width: auto;
      transition: .35s;
    }

    &:hover {
      transform: translateY(-5px);
      box-shadow: 0px 4px 25px 0px rgba(0, 0, 0, .25);

      .grid-view-img {
        opacity: 0.9;
      }
    }
  }
</style>
